import { useTranslation } from 'react-i18next'

import { PriceRule, PriceRuleStatus } from '../../../../../types/booking/booking'
import { toDisplayOnlyDate } from '../../../../../utils/dateUtils'

export const PriceRuleStatusBadge = ({ status }: { status?: PriceRuleStatus }) => {
  const { t } = useTranslation('pricing')

  switch (status) {
    case PriceRuleStatus.ACTIVE:
      return <span className="badge badge-success">{t('pricing.status.active')}</span>
    case PriceRuleStatus.SUPERSEDED:
      return <span className="badge">{t('pricing.status.superseded')}</span>
    default:
      return <span className="badge badge-danger">{t('pricing.status.archived')}</span>
  }
}

export const usePriceRuleFormat = () => {
  const { t, i18n } = useTranslation('pricing')

  return {
    period: (rule: PriceRule) =>
      rule.effectiveTo
        ? `${toDisplayOnlyDate(rule.effectiveFrom, i18n.language)} – ${toDisplayOnlyDate(rule.effectiveTo, i18n.language)}`
        : t('pricing.manager.from', { date: toDisplayOnlyDate(rule.effectiveFrom, i18n.language) }),
    startTimes: (rule: PriceRule) => `${rule.interval.startTime.slice(0, 5)} – ${rule.interval.endTime.slice(0, 5)}`,
  }
}

/** Prices sorted by session length, shortest first. */
export const sortedAmounts = (rule: PriceRule) =>
  [...rule.amounts].sort((a, b) => a.durationMinutes - b.durationMinutes)
